import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { request } from '../../../config';
import { Autocomplete, Box, TextField } from '@mui/material';
import transferConfirmation from './../img/transfer-confirmation.svg';
import { getFormatedDate } from '../../../helpers/fotmatDate';
import Loading from '../Loading/Loading';
import DatePickerInput from './DatePicker/DatePicker';
import $ from 'jquery';

function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class Create extends Component {
    state = {
        submit: false,
        warrantyCategoryId: null,
        warrantyCategories: [],
        warrantySubCategories: [],
        filteredSubCategories: [],
        warrantySubCategoryId: null,
        warrantyTypes: [],
        warrantyTypeId: null,
        amount: "",
        startDate: null,
        endDate: null,
        beneficiaryName: '',
        beneficiaryAddress: '',
        beneficiaryVoen: '',
        files: [],
        accounts: [],
        accountId: null,
        tenderDate: null,
        tenderId: '',
        tenderInfo: '',
        contractNo: '',
        contractDate: null,
        isLoading: false,
        orderId: null,
        currency: '',
        disabledWarrantySubCategory: false,
    }

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    chooseFile = (event) => {
        let files = this.state.files;

        const chosenFiles = Array.from(event.target.files);
        const maxSize = 25 * 1024 * 1024;
        const allowedTypes = [
            'application/pdf',
            'image/svg+xml',
            'image/jpeg',
            'image/png',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword',
            'application/zip',
            'application/x-rar-compressed',
        ];
        const errors = [];

        chosenFiles.forEach(file => {
            if (!allowedTypes.includes(file.type)) {
                errors.push(this.props.t("Unsupported file type"));
            } else if (file.size > maxSize) {
                errors.push(this.props.t("Due to the large file size, please upload it in ZIP or RAR format"));
            } else {
                files.push({ files: file, fileName: file.name });
                this.setState({ files: files })
            }
        });

        if (errors.length) {
            this.props.alertState(true, 'error', this.props.t('an error occurred'), errors.join('\n'));
        }
    }

    deleteFile = (index) => {
        let files = this.state.files;
        files.splice(index, 1);
        this.setState({ files: files });
    }

    downloadFile = (index) => {
        let arrrayBuffer = this.state.files[index].files;
        saveFile(this.state.files[index].fileName, null, arrrayBuffer);
    }

    getData = (callback = () => { }) => {
        this.setState({ isLoading: true });
        let getDataRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("warranty/getWarrantyPayload", getDataRequestBody))
            .then(res => res.text())
            .then((getDataResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getDataResponse = JSON.parse(getDataResponseJSON);
                if (getDataResponse.status.statusCode !== 1) {
                    if (getDataResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getDataResponse.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    this.setState({ ...getDataResponse, filteredSubCategories: getDataResponse?.warrantySubCategories ?? [], isLoading: false }, callback)
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    showAccounts = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let getNoCardAccountListForCustomerRequestBody = customerType === 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            isBalanceAccount: 0
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            isBalanceAccount: 0
        }
        fetch(request("account/getNoCardAccountListFor" + customerType + "Customer", getNoCardAccountListForCustomerRequestBody))
            .then(res => res.text())
            .then((getNoCardAccountListForCustomerResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getNoCardAccountListForCustomerResponse = JSON.parse(getNoCardAccountListForCustomerResponseJSON);
                if (getNoCardAccountListForCustomerResponse.status.statusCode !== 1 && getNoCardAccountListForCustomerResponse.status.statusCode !== 126) {
                    this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getNoCardAccountListForCustomerResponse.status.statusCode));
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
                else {
                    if (getNoCardAccountListForCustomerResponse.status.statusCode === 126) {
                        getNoCardAccountListForCustomerResponse.accountList = [];
                    }
                    this.setState({ accounts: getNoCardAccountListForCustomerResponse.accountList ?? [] });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    check = (e) => {
        e.preventDefault();
        this.setState({ submit: true });

        let { warrantyCategoryId, warrantySubCategoryId, warrantyTypeId, accountId, amount,
            startDate, endDate, beneficiaryName, beneficiaryAddress, beneficiaryVoen, tenderId, tenderDate, tenderInfo, contractDate, contractNo } = this.state;
        const isVoenValid = warrantyTypeId == 369 ? beneficiaryVoen.length === 10 : beneficiaryVoen;
        const requiredFields = [warrantyCategoryId, warrantySubCategoryId, warrantyTypeId, accountId, amount, startDate, endDate, beneficiaryName, beneficiaryAddress, isVoenValid];

        if (warrantyCategoryId === 372) {
            requiredFields.push(tenderId, tenderDate, tenderInfo);
        }

        if (warrantyCategoryId === 371) {
            requiredFields.push(contractDate, contractNo);
        }

        const isFormValid = requiredFields.every(Boolean);
        if (isFormValid) {
            this.create(e)
        }
    }

    create = (e) => {
        e.preventDefault();
        let { orderId, warrantyCategoryId, warrantySubCategoryId, warrantyTypeId, accountId, amount, startDate, endDate, beneficiaryName, beneficiaryAddress, beneficiaryVoen, tenderId, tenderDate, tenderInfo, contractDate, contractNo } = this.state;
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let createRequestBody = {
            orderId, warrantyCategoryId, warrantySubCategoryId, warrantyTypeId,
            accountId, amount, beneficiaryName,
            beneficiaryAddress, beneficiaryVoen, tenderId, tenderInfo, contractNo,
            contractDate: getFormatedDate(contractDate, 'dd.mm.yyyy'),
            startDate: getFormatedDate(startDate, 'dd.mm.yyyy'),
            endDate: getFormatedDate(endDate, 'dd.mm.yyyy'),
            tenderDate: getFormatedDate(tenderDate, 'dd.mm.yyyy'),
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            compId: localStorage.getItem('compId')
        }

        let data = new FormData();
        data.append('reqObject', JSON.stringify(createRequestBody));
        this.state.files.map(file => {
            data.append('files', file.files)
        })

        fetch(request(`warranty/${orderId ? 'e-contract/update-warranty-orderForm' : 'createWarrantyOrderWithForm'}`, data, "POST_FORM"))
            .then(res => res.text())
            .then((createResponseJSON) => {
                const JSON = require('true-json-bigint');
                let createResponse = JSON.parse(createResponseJSON);
                if (createResponse.statusCode !== 1) {
                    if (createResponse.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(createResponse.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(orderId ? 'The operation was completed successfully' : 'guarantee order has been received'), null, null, () => this.props.history.push('/dashboard/guarantees/list/orders'));
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getWarrantyDetail = (id) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getWarrantyDetailRequestBody = {
            token: localStorage.getItem('token'),
            id
        }
        fetch(request(`warranty/getOrderDetail`, getWarrantyDetailRequestBody))
            .then(res => res.text())
            .then((getWarrantyDetailResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getWarrantyDetailResponse = JSON.parse(getWarrantyDetailResponseJSON);
                if (getWarrantyDetailResponse.status.statusCode !== 1 || getWarrantyDetailResponse.statusId !== 0) {
                    if (getWarrantyDetailResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getWarrantyDetailResponse.statusId !== 0 ? this.props.t('application already completed') : getWarrantyDetailResponse.status.statusCode), "/dashboard/guarantees/list/orders");
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    let { warrantyCategories, warrantySubCategories } = this.state;
                    let category = warrantyCategories.find(item => item.name?.trim() === getWarrantyDetailResponse.warrantyCategory?.trim());
                    let subCategory = warrantySubCategories.find(item => item.name?.trim() === getWarrantyDetailResponse.warrantySubCategory?.trim());
                    this.setState({
                        item: { ...getWarrantyDetailResponse, orderId: id },
                        warrantyCategoryId: category?.id,
                        warrantySubCategoryId: subCategory?.id,
                        filteredSubCategories: category ? warrantySubCategories.filter(item => category.id == 372 ? item.id == 121 : item.id != 121) : this.state.filteredSubCategories,
                        amount: getWarrantyDetailResponse.warrantyAmount || '',
                        currency: getWarrantyDetailResponse.currency || '',
                        beneficiaryName: getWarrantyDetailResponse.beneficiaryName || '',
                        beneficiaryAddress: getWarrantyDetailResponse.beneficiaryAddress || '',
                        beneficiaryVoen: getWarrantyDetailResponse.beneficiaryVoen || '',
                        tenderId: getWarrantyDetailResponse.tenderId || '',
                        econtractNumber: getWarrantyDetailResponse.econtractNumber || '',
                        contractDate: getWarrantyDetailResponse.contractDate ? new Date(getWarrantyDetailResponse.contractDate) : null,
                        startDate: getWarrantyDetailResponse.warrantyDate ? new Date(getWarrantyDetailResponse.warrantyDate) : null,
                        endDate: getWarrantyDetailResponse.endDate ? new Date(getWarrantyDetailResponse.endDate) : null,
                        disabledWarrantySubCategory: getWarrantyDetailResponse.warrantySubCategory ? true : false
                    })
                    // }
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
        // }
    }

    componentDidMount() {
        this.showAccounts();
        let { orderId } = this.props.match.params;
        if (orderId) {
            this.setState({ orderId }, () => this.getData(() => this.getWarrantyDetail(orderId)));
        } else {
            this.getData();
        }
    }

    render() {
        let { t } = this.props;
        let { submit, warrantyCategoryId, amount, accounts, accountId, warrantyCategories, warrantySubCategoryId, warrantySubCategories, filteredSubCategories, warrantyTypes, warrantyTypeId,
            startDate, endDate, beneficiaryName, beneficiaryAddress, beneficiaryVoen, tenderId, tenderInfo, tenderDate, contractNo, contractDate, isLoading, econtractNumber, currency, orderId, disabledWarrantySubCategory } = this.state;
        return (
            <Fragment>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.push("/dashboard/guarantees/list/orders")}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3051C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.30512 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Create guarantee')}</h2>
                    </div>
                </div>
                <div className="dashboard-payment-container">
                    <div className="dashboard-payment-container-data-section">
                        <div className="dashboard-contact-section py-4">
                            {isLoading ? <Loading /> :
                                <form onSubmit={(e) => this.check(e)} className="dashboard-account-container-component dashboard-contact-section-form align-items-end" >
                                    <Box className='dashboard-account-container-component-block invoice align-items-end'>
                                        <Autocomplete
                                            sx={{ flexBasis: 300 }}
                                            options={warrantyCategories}
                                            readOnly={orderId ? true : false}
                                            getOptionLabel={option => option.name}
                                            value={warrantyCategories.find(item => item.id == warrantyCategoryId) || null}
                                            onChange={(event, newValue) => this.setState({ warrantyCategoryId: newValue?.id }, () => {
                                                if (this.state.warrantyCategoryId == 372) {
                                                    this.setState({ warrantySubCategoryId: 121, contractDate: null, contractNo: '', filteredSubCategories: warrantySubCategories.filter(item => item.id == 121) })
                                                } else {
                                                    this.setState({ tenderDate: null, tenderId: '', tenderInfo: '', warrantySubCategoryId: null, filteredSubCategories: warrantySubCategories.filter(item => item.id != 121) })
                                                }
                                            })}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                error={!warrantyCategoryId && submit}
                                                placeholder={t('Choose')}
                                                label={t('Type')}
                                            />} />
                                        <Autocomplete
                                            sx={{ flexBasis: 300 }}
                                            options={warrantyCategoryId ? filteredSubCategories : []}
                                            getOptionLabel={option => option.name}
                                            readOnly={disabledWarrantySubCategory}
                                            value={filteredSubCategories.find(item => item.id == warrantySubCategoryId) || null}
                                            onChange={(event, newValue) => this.setState({ warrantySubCategoryId: newValue?.id })}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                error={!warrantySubCategoryId && submit}
                                                placeholder={t('Choose')}
                                                label={t('Subtype')}
                                            />} />
                                        {this.state.warrantyCategoryId == 372 && <>
                                            <TextField variant="outlined" sx={{ flexBasis: 300 }} inputProps={{ maxLength: 150 }} error={!tenderId && submit} label={t('Tender ID')} placeholder={t('Daxil edin')} value={tenderId} onChange={(e) => this.setState({ tenderId: e.target.value })} />
                                            <Box sx={{ flexBasis: 300 }}>
                                                <label>{t("Tender tarixi")}</label>
                                                <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                                    <DatePickerInput value={tenderDate} error={!tenderDate && submit} name="tenderDate" updateDate={this.updateDate} />
                                                </div>
                                            </Box>
                                            <TextField variant="outlined" sx={{ flexBasis: 300 }} inputProps={{ maxLength: 150 }} error={!tenderInfo && submit} label={t('Tender information')} placeholder={t('Daxil edin')} value={tenderInfo} onChange={(e) => this.setState({ tenderInfo: e.target.value })} />
                                        </>}
                                        {this.state.warrantyCategoryId == 371 && <>
                                            <TextField variant="outlined" sx={{ flexBasis: 300 }} inputProps={{ maxLength: 150 }} error={!contractNo && submit} label={t('Contract number')} placeholder={t('Daxil edin')} value={contractNo} onChange={(e) => this.setState({ contractNo: e.target.value })} />
                                            {orderId && <TextField variant="outlined" sx={{ flexBasis: 300 }} inputProps={{ maxLength: 150 }} InputProps={{ readOnly: true }} label={t('Electronic contract number')} placeholder={t('Daxil edin')} value={econtractNumber} onChange={(e) => this.setState({ econtractNumber: e.target.value })} />}
                                            <Box sx={{ flexBasis: 300 }}>
                                                <label>{t("Contract date")}</label>
                                                <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                                    <DatePickerInput readOnly={orderId} value={contractDate} error={!contractDate && submit} name="contractDate" updateDate={this.updateDate} />
                                                </div>
                                            </Box>
                                        </>}
                                        <Autocomplete
                                            sx={{ flexBasis: 300 }}
                                            options={warrantyTypes}
                                            getOptionLabel={option => option.name}
                                            value={warrantyTypes.find(item => item.id == warrantyTypeId) || null}
                                            onChange={(event, newValue) => this.setState({ warrantyTypeId: newValue?.id, ...(!orderId && { beneficiaryVoen: '' }) })}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                error={!warrantyTypeId && submit}
                                                placeholder={t('Choose')}
                                                label={t('category')}
                                            />} />
                                        <Autocomplete
                                            sx={{ flexBasis: 300 }}
                                            options={orderId ? accounts.filter(account => account.currName === currency) : accounts}
                                            getOptionLabel={option => option.iban + " / " + option.currentBalance + " " + option.currName}
                                            value={accounts.find(item => item.accountId == accountId) || null}
                                            onChange={(event, newValue) => this.setState({ accountId: newValue?.accountId })}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                error={!accountId && submit}
                                                placeholder={t('Choose')}
                                                label={t('current account')}
                                            />} />
                                        <TextField variant="outlined" sx={{ flexBasis: 300 }} InputProps={{ readOnly: orderId }} inputProps={{ maxLength: 15 }} error={!amount && submit} label={t('Amount')} value={amount} onChange={(e) => this.setState({ amount: e.target.value.replace(/^(\d+(\.\d{0,2})?)?.*$/, '$1') })} />
                                        <TextField variant="outlined" sx={{ flexBasis: 300 }} label={t('currency')} value={orderId ? currency : accounts.find(item => item.accountId == accountId)?.currName} InputProps={{ readOnly: true }} />
                                        <Box sx={{ flexBasis: 300 }}>
                                            <label>{t("Opening date")}</label>
                                            <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                                <DatePickerInput readOnly={orderId} value={startDate} endDate={endDate} error={!startDate && submit} name="startDate" updateDate={this.updateDate} />
                                            </div>
                                        </Box>
                                        <Box sx={{ flexBasis: 300 }}>
                                            <label>{t("expiration date")}</label>
                                            <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                                <DatePickerInput readOnly={orderId} value={endDate} startDate={startDate} error={!endDate && submit} name="endDate" updateDate={this.updateDate} />
                                            </div>
                                        </Box>
                                    </Box>

                                    <h6 className='w-100 mb-0 mt-3'>{t('Beneficiary information')}</h6>
                                    <Box className='dashboard-account-container-component-block invoice'>
                                        <TextField variant="outlined" sx={{ flexBasis: 300 }} InputProps={{ readOnly: orderId }} inputProps={{ maxLength: 150 }} error={!beneficiaryName && submit} label={t('First name')} placeholder={t('Daxil edin')} value={beneficiaryName} onChange={(e) => this.setState({ beneficiaryName: e.target.value })} />
                                        <TextField variant="outlined" sx={{ flexBasis: 300 }} InputProps={{ readOnly: orderId }} inputProps={{ maxLength: 150 }} error={!beneficiaryAddress && submit} label={t('Address')} placeholder={t('Daxil edin')} value={beneficiaryAddress} onChange={(e) => this.setState({ beneficiaryAddress: e.target.value.replace(/[\u0400-\u04FF]/g, '') })} />
                                        <TextField variant="outlined" sx={{ flexBasis: 300 }} InputProps={{ readOnly: orderId }} inputProps={{ maxLength: warrantyTypeId == 369 ? 10 : undefined }} error={warrantyTypeId == 369 ? (beneficiaryVoen.length !== 10 && submit) : (!beneficiaryVoen && submit)} label={t('tin')} placeholder={t('Daxil edin')} value={beneficiaryVoen} onChange={(e) => this.setState({ beneficiaryVoen: warrantyTypeId == 369 ? e.target.value.replace(/[^0-9]/g, "") : e.target.value })} />
                                    </Box>

                                    <Box sx={{ width: 300 }} className="dashboard-payment-container-data-section-content-container-form-input-group__grid ml-3">
                                        <label className="dashboard-payment-container-data-section-content-container-form-label">{t('Add document')}</label>
                                        <div className="dashboard-payment-container-data-section-content-container-form-input-box">
                                            <input type="text" value={this.state.fileNameString} className="dashboard-payment-container-data-section-content-container-form-input" />
                                            <button type='button' className="dashboard-payment-container-data-section-content-container-form-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ zIndex: 0 }}>
                                                    <path d="M7.5 14.7916C7.41667 14.7916 7.34167 14.775 7.25833 14.7416C7.025 14.65 6.875 14.4166 6.875 14.1666V9.16663C6.875 8.82496 7.15833 8.54163 7.5 8.54163C7.84167 8.54163 8.125 8.82496 8.125 9.16663V12.6583L8.725 12.0583C8.96667 11.8166 9.36667 11.8166 9.60833 12.0583C9.85 12.3 9.85 12.7 9.60833 12.9416L7.94167 14.6083C7.825 14.725 7.65833 14.7916 7.5 14.7916Z" fill="#757575" />
                                                    <path d="M7.49997 14.7917C7.34164 14.7917 7.18331 14.7333 7.05831 14.6083L5.39164 12.9417C5.14997 12.7 5.14997 12.3 5.39164 12.0583C5.6333 11.8167 6.03331 11.8167 6.27497 12.0583L7.94164 13.725C8.1833 13.9667 8.1833 14.3667 7.94164 14.6083C7.81664 14.7333 7.6583 14.7917 7.49997 14.7917Z" fill="#757575" />
                                                    <path d="M12.5 18.9583H7.50002C2.97502 18.9583 1.04169 17.025 1.04169 12.5V7.49996C1.04169 2.97496 2.97502 1.04163 7.50002 1.04163H11.6667C12.0084 1.04163 12.2917 1.32496 12.2917 1.66663C12.2917 2.00829 12.0084 2.29163 11.6667 2.29163H7.50002C3.65835 2.29163 2.29169 3.65829 2.29169 7.49996V12.5C2.29169 16.3416 3.65835 17.7083 7.50002 17.7083H12.5C16.3417 17.7083 17.7084 16.3416 17.7084 12.5V8.33329C17.7084 7.99163 17.9917 7.70829 18.3334 7.70829C18.675 7.70829 18.9584 7.99163 18.9584 8.33329V12.5C18.9584 17.025 17.025 18.9583 12.5 18.9583Z" fill="#757575" />
                                                    <path d="M18.3334 8.95828H15C12.15 8.95828 11.0417 7.84995 11.0417 4.99995V1.66662C11.0417 1.41662 11.1917 1.18328 11.425 1.09162C11.6584 0.991617 11.925 1.04995 12.1084 1.22495L18.775 7.89162C18.95 8.06662 19.0084 8.34162 18.9084 8.57495C18.8084 8.80828 18.5834 8.95828 18.3334 8.95828ZM12.2917 3.17495V4.99995C12.2917 7.14995 12.85 7.70828 15 7.70828H16.825L12.2917 3.17495Z" fill="#757575" />
                                                </svg>
                                            </button>
                                            <input id="file" type="file" className="dashboard-payment-container-data-section-content-container-form-input__file" accept=".pdf,.svg,.jpg,.jpeg,.png,.docx,.doc,.zip,.rar" multiple={true} onChange={this.chooseFile} />
                                        </div>
                                        {
                                            this.state.files.map((item, index) => (
                                                <Box sx={{ width: 300 }} className="dashboard-file-list-transfer-abroad">
                                                    <li className="dashboard-file-item" key={index}>
                                                        <div className="dashboard-file-item-left">
                                                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M2.09375 14.6562C3.90625 16.4688 6.84375 16.4688 8.65625 14.6562C10.3438 12.9688 13.0938 10.2188 14.7812 8.53125C14.9375 8.375 14.9375 8.15625 14.7812 8L14.25 7.46875C14.0938 7.3125 13.875 7.3125 13.7188 7.46875C12.0312 9.15625 9.28125 11.9062 7.59375 13.5938C6.375 14.8125 4.375 14.8125 3.15625 13.5938C1.9375 12.375 1.9375 10.375 3.15625 9.15625L10.1875 2.125C11 1.3125 12.3125 1.3125 13.125 2.125C13.9375 2.9375 13.9375 4.25 13.125 5.0625L7.21875 10.9688C6.8125 11.375 6.15625 11.375 5.75 10.9688C5.375 10.5938 5.375 9.9375 5.75 9.53125L10.7812 4.53125C10.9375 4.375 10.9375 4.15625 10.7812 4L10.25 3.46875C10.0938 3.3125 9.875 3.3125 9.71875 3.46875L4.71875 8.46875C3.71875 9.46875 3.71875 11.0625 4.71875 12.0312C5.6875 13.0312 7.28125 13.0312 8.25 12.0312L14.1875 6.125C15.5938 4.71875 15.5938 2.46875 14.1875 1.0625C12.7812 -0.34375 10.5312 -0.34375 9.125 1.0625L2.09375 8.09375C0.28125 9.90625 0.28125 12.8438 2.09375 14.6562Z" fill="#849097" />
                                                            </svg>
                                                            <button type="button" className="dashboard-file-item-title" onClick={this.downloadFile.bind(this, index)}>{item.fileName}</button>
                                                        </div>
                                                        <button type="button" className="dashboard-file-item-right" onClick={this.deleteFile.bind(this, index)}>
                                                            <svg className="dashboard-transfer-list-table-icon" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M8.375 13H9.125C9.3125 13 9.5 12.8438 9.5 12.625V5.875C9.5 5.6875 9.3125 5.5 9.125 5.5H8.375C8.15625 5.5 8 5.6875 8 5.875V12.625C8 12.8438 8.15625 13 8.375 13ZM13.5 2.5H10.9062L9.84375 0.75C9.59375 0.34375 9.03125 0 8.5625 0H5.40625C4.9375 0 4.375 0.34375 4.125 0.75L3.0625 2.5H0.5C0.21875 2.5 0 2.75 0 3V3.5C0 3.78125 0.21875 4 0.5 4H1V14.5C1 15.3438 1.65625 16 2.5 16H11.5C12.3125 16 13 15.3438 13 14.5V4H13.5C13.75 4 14 3.78125 14 3.5V3C14 2.75 13.75 2.5 13.5 2.5ZM5.34375 1.59375C5.375 1.5625 5.46875 1.5 5.5 1.5H5.53125H8.46875C8.5 1.5 8.59375 1.5625 8.625 1.59375L9.15625 2.5H4.8125L5.34375 1.59375ZM11.5 14.5H2.5V4H11.5V14.5ZM4.875 13H5.625C5.8125 13 6 12.8438 6 12.625V5.875C6 5.6875 5.8125 5.5 5.625 5.5H4.875C4.65625 5.5 4.5 5.6875 4.5 5.875V12.625C4.5 12.8438 4.65625 13 4.875 13Z" fill="#586268" />
                                                            </svg>
                                                        </button>
                                                    </li>
                                                </Box>
                                            ))
                                        }
                                    </Box>
                                    <div className="dashboard-payment-container-data-section-content-container-form-footer d-flex justify-content-end">
                                        <button type='submit' className="dashboard-contact-section-button">{orderId ? t('Complete guarantee') : t('Create guarantee')}</button>
                                    </div>
                                </form>
                            }
                        </div>
                    </div>
                    <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('Information')}</h3>
                        </div>
                        <div className="dashboard-payment-container-confirmation-section-content">
                            <img src={transferConfirmation} alt="img" className="dashboard-payment-container-confirmation-section-content-image" />
                            <div className="dashboard-payment-container-confirmation-section-content-description">
                                <p>{t('guarantee text')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default translate("translation")(Create);